import script from "./AllMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllMenu.vue?vue&type=script&lang=ts&setup=true"

import "./AllMenu.vue?vue&type=style&index=0&id=5fde18a2&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fde18a2"]])

export default __exports__